import token from './tokenReducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  token
});

export default rootReducer;
